import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import BottomNav from "./BottomNav";
import Footer from "./Footer";

function PageFallback() {
  return (
    <div className="space-y-3" aria-busy="true" aria-label="Caricamento pagina" data-testid="page-loading">
      <div className="h-6 w-48 animate-pulse rounded bg-[#F7F9FC]" />
      <div className="h-24 animate-pulse rounded-xl bg-[#F7F9FC]" />
    </div>
  );
}

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-4 pb-24 sm:px-6 sm:py-8 sm:pb-8">
        <Suspense fallback={<PageFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <BottomNav />
    </div>
  );
}
